import React, { useRef, useEffect, useState } from "react";
import "./CenterMedia.css";
import { useVideoManager } from "../context/VideoManager";

const CenterMedia = ({
  media,
  column = "center",
  size,
  userInteracted,
  paddingLeft = 0,
  paddingRight = 0,
  responsivePadding = false, // New: Toggle for responsive padding
  maxPadding = 300, // New: Maximum padding for larger screens
  disablePaddingOnMobile = false, // New: Disable padding on mobile screens
}) => {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [volume, setVolume] = useState(0);
  const [dynamicPadding, setDynamicPadding] = useState({
    paddingLeft,
    paddingRight,
  });
  let hasUserInteracted = userInteracted;

  const { handleVideoUnmute } = useVideoManager();

  const handleMuteToggle = (videoRef) => {
    if (videoRef) {
      const isMuted = videoRef.muted;
      if (!isMuted) {
        handleVideoUnmute(videoRef); // Notify VideoManager
      }
      videoRef.muted = !isMuted; // Toggle mute state
    }
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = true; // Set audio to off

      videoRef.current.addEventListener("mouseover", () => {
        setShowControls(true);
      });

      videoRef.current.addEventListener("mouseout", () => {
        setShowControls(false);
      });

      window.addEventListener("scroll", centerMediaHandleScrollMediaComponents);
    }

    window.addEventListener("click", () => {
      hasUserInteracted = true;
    });

    return () => {
      window.removeEventListener(
        "scroll",
        centerMediaHandleScrollMediaComponents
      );
    };
  }, [videoRef]);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (responsivePadding) {
        console.log("Screen Width:", screenWidth);
        console.log("disablePaddingOnMobile:", disablePaddingOnMobile);
        console.log("Max Padding", maxPadding);

        if (screenWidth < 768 && disablePaddingOnMobile) {
          console.log("Mobile: Padding disabled");
          setDynamicPadding({ paddingLeft: 0, paddingRight: 0 });
        } else if (screenWidth < 768 && !disablePaddingOnMobile) {
          const calc = (screenWidth / 768) * (maxPadding - screenWidth);
          const calculatedPadding = Math.min(calc, maxPadding);
          console.log("Mobile: Calculated Padding", calculatedPadding);
          setDynamicPadding({
            paddingLeft: calculatedPadding,
            paddingRight: calculatedPadding,
          });
        } else {
          const calculatedPadding = Math.min(
            (screenWidth / 1920) * maxPadding,
            maxPadding
          );
          console.log("Desktop/Tablet: Calculated Padding", calculatedPadding);
          setDynamicPadding({
            paddingLeft: calculatedPadding,
            paddingRight: calculatedPadding,
          });
        }
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [responsivePadding, maxPadding, disablePaddingOnMobile]);

  const centerMediaHandleScrollMediaComponents = () => {
    const videoRect = videoRef.current?.getBoundingClientRect();
    if (videoRect) {
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const videoMiddle = window.scrollY + videoRect.top + videoRect.height / 2;

      if (
        scrollPosition < videoMiddle - videoRect.height * 0.85 ||
        scrollPosition > videoMiddle + videoRect.height * 0.85
      ) {
        if (videoRef.current && !videoRef.current.paused) {
          videoRef.current.pause();
          setIsPlaying(false);
        }
      } else {
        if (videoRef.current && videoRef.current.paused) {
          if (hasUserInteracted) {
            videoRef.current.play();
            setIsPlaying(true);
          }
        }
      }
    }
  };

  const renderMedia = () => {
    const style = {
      height: media.height || "auto",
      width: media.width || "100%",
      objectFit: media.objectFit || "contain",
      display: "block",
      margin: media.position === "center" ? "auto" : "initial",
      alignSelf: media.verticalAlign || "center",
      paddingLeft: `${
        responsivePadding ? dynamicPadding.paddingLeft : paddingLeft
      }px`,
      paddingRight: `${
        responsivePadding ? dynamicPadding.paddingRight : paddingRight
      }px`,
    };

    if (media.type === "image") {
      return (
        <img
          src={media.src}
          alt={media.alt}
          style={style}
          className={`center-media-image ${size}`}
        />
      );
    } else if (media.type === "video") {
      return (
        <div className="center-media-video-container">
          <video
            className="center-media-media-video"
            playsInline
            webkit-playsinline="true"
            preload="metadata"
            style={style}
            ref={videoRef}
            src={media.src}
            loop
            muted={muted}
            volume={volume}
            controls={showControls}
            onClick={(e) => handleMuteToggle(e.target)}
            onError={(e) => console.error("Video error:", e.target.error)}
            onLoadedMetadata={() => {
              if (!isPlaying) {
                videoRef.current.play();
                setIsPlaying(true);
              }
            }}
          />
        </div>
      );
    }
  };

  return (
    <div
      className="grid-container-center-media"
      // style={{
      //   paddingLeft: `${responsivePadding ? dynamicPadding.paddingLeft : paddingLeft}px`,
      //   paddingRight: `${responsivePadding ? dynamicPadding.paddingRight : paddingRight}px`,
      // }}
    >
      <div className={`center-media-grid-item ${column}`}>{renderMedia()}</div>
    </div>
  );
};

export default CenterMedia;
